import React, { useCallback, useEffect, useState } from "react";
import Container from "../../components/Container";
import MainCard from "../../components/MainCard";
import PageContainer from "../../components/PageContainer";
import ImageWithTooltip from "../../components/ImageWithTooltip";
import DocLists from "../../sections/standards/DocLists";
import { getAboutAudit } from "../../api/about";

const AuditBoard = () => {
  const [pageData, setPageData] = useState(null);

  const getData = useCallback(
    () =>
      getAboutAudit()
        .then((res) => setPageData(res))
        .catch((err) => console.log(err)),
    [setPageData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  console.log("pageData", pageData);

  return (
    <PageContainer bgImg="/images/hero-image.jpeg" title="เกี่ยวกับสำนักงาน">
      <Container isAlignTop>
        <MainCard>
          <div className={`flex flex-col`}>
            <div className="header-content">
              <h2 className="header-content__title">คณะกรรมการตรวจสอบ</h2>
            </div>

            {pageData?.banner.length &&
              pageData.banner.map((item, index) => (
                <ImageWithTooltip
                  key={index}
                  src={item.path}
                  className="object-contain rounded-lg"
                  alt={item.altText}
                />
              ))}
          </div>
          <div className="header-content">
            <h2 className="header-content__title">
              ประกาศ (คณะกรรมการตรวจสอบ)
            </h2>
          </div>

          <DocLists
            docs={pageData?.docgroup.flatMap((item) => item.docitem) ?? []}
            keyLabel="doctitle"
            bgColor="#fff"
            onDocClick={(doc) => window.open(doc.doclink)}
          />
        </MainCard>
      </Container>
    </PageContainer>
  );
};

export default AuditBoard;
